import { useQuery } from "@tanstack/react-query";
import { remindersQueryKeys } from "../queries/reminders.queries";
import { getAllRemindersConfig } from "../actions/get-all-reminders-config.actions";
import { Reminder } from "../interfaces/IRemiders";

export const useRemindersQuery = () => {
  return useQuery({
    queryKey: remindersQueryKeys.all,
    queryFn: () => getAllRemindersConfig(),
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 10,
    select: (data: any) => (data?.items as Reminder[]) || [],
  });
};
